function pascalToCamel(str: string) {
  return str.charAt(0).toLowerCase() + str.slice(1);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function convertPascalKeysToCamel(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(convertPascalKeysToCamel);
  }
  if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [pascalToCamel(k), convertPascalKeysToCamel(v)]),
    );
  }
  return obj;
}
